import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { BrevConnectTrigger } from "components/BrevConnect/BrevConnectTrigger";
import { Button } from "components/Graphs/Button";

export const BrevConnectActionTrigger: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => <BrevConnectTrigger>{children}</BrevConnectTrigger>;

export const BrevConnectAction: React.FC<{
  className?: string;
  isAdmin: boolean;
}> = ({ className, isAdmin }) => {
  if (!isAdmin) return null;

  return (
    <BrevConnectActionTrigger>
      <Button className={className} variant="secondary">
        <span className="flex items-center gap-1.5">
          <PlusIcon className="h-4 w-4" />
          Connect a local device
        </span>
      </Button>
    </BrevConnectActionTrigger>
  );
};

export const AddCloudComputeAction: React.FC<{
  onAddCloud: () => void;
}> = ({ onAddCloud }) => (
  <Button onClick={onAddCloud}>
    <span className="flex items-center gap-1.5 text-zinc-900">
      <PlusIcon className="h-4 w-4" />
      Create a cloud instance
    </span>
  </Button>
);

export const AllComputeCreationActions: React.FC<{
  isAdmin: boolean;
  onAddCloud: () => void;
}> = ({ isAdmin, onAddCloud }) => (
  <>
    <BrevConnectAction isAdmin={isAdmin} />
    <AddCloudComputeAction onAddCloud={onAddCloud} />
  </>
);
